import { Order } from '../components/cart/model';
import { OrderSummary } from '../components/order-summary/model';
import { ShippingItem } from '../components/shipping-list/model';
import { VoucherResponse } from '../components/voucher/model';
import { OrderDetails } from '../controllers/order-details/model';
import { InstallmentResponse } from '../components/installment/model';
const baseUrl = '/api';

const getProvinces = () => {
    return $.get('/wservice/city.ashx?rv=' + Date.now());
};

const getCities = provinceId => {
    const request = {
        url: '/wservice/city.ashx?rv=' + Date.now(),
        method: 'GET',
        data: {
            action: 'city',
            provinceid: provinceId
        }
    };

    return $.ajax(request);
};

const getRegions = cityId => {
    const request = {
        url: '/wservice/city.ashx?rv=' + Date.now(),
        method: 'GET',
        data: {
            action: 'mahdoode',
            cityid: cityId
        }
    };

    return $.ajax(request);
};

const getSuburbs = (cityId, regionId) => {
    const request = {
        url: '/wservice/city.ashx?rv=' + Date.now(),
        method: 'GET',
        data: {
            action: 'mahale',
            cityid: cityId,
            mahdoodeh: regionId
        }
    };

    return $.ajax(request);
};

const getAddress = (addressId, forceExUser?: number, uid?: number, hps?: string) => {
    if (typeof forceExUser == 'undefined') {
        forceExUser = 0;
    }
    if (typeof uid == 'undefined') {
        uid = 0;
    }
    if (typeof hps == 'undefined') {
        hps = "";
    }
    const getAddressRequest = {
        url: '/wservice/useraddressws.ashx?rv=' + Date.now(),
        method: 'GET',
        data: {
            action: 'get',
            addressId,
            forceExUser: forceExUser,
            uid: uid,
            pass: hps
        }
    };

    return $.ajax(getAddressRequest);
};

const getAddresses = (forceExUser?: number, uid?: number, hps?: string) => {
    if (typeof forceExUser == 'undefined') {
        forceExUser=0;
    }
    if (typeof uid == 'undefined') {
        uid = 0;
    }
    if (typeof hps == 'undefined') {
        hps = "";
    }
    const getAddressRequest = {
        url: '/wservice/useraddressws.ashx?rv=' + Date.now(),
        method: 'GET',
        data: {
            action: 'address-list',
            forceExUser: forceExUser,
            uid: uid,
            pass: hps
        }
    };

    return $.ajax(getAddressRequest);
};

const deleteAddress = (addressId, forceExUser?: number, uid?: number, hps?: string) => {
    if (typeof forceExUser == 'undefined') {
        forceExUser = 0;
    }
    if (typeof uid == 'undefined') {
        uid = 0;
    }
    if (typeof hps == 'undefined') {
        hps = "";
    }
    const request = {
        url: '/wservice/useraddressws.ashx?rv=' + Date.now(),
        method: 'GET',
        data: {
            action: 'delete-address',
            addressId,
            forceExUser: forceExUser,
            uid: uid,
            pass: hps
        }
    };

    return $.ajax(request);
};

const addOrUpdateAddressAsync = (addressId, cityId, suburbId, postalCode, address, latitude ,longitude, forceExUser?: number, uid?: number, hps?: string) => {
    
    const request = {
        url: '/wservice/useraddressws.ashx?rv=' + Date.now(),
        method: 'GET',
        data: {
            action: 'add',
            cityid: cityId,
            mahaleid: suburbId,
            codePosti: postalCode,
            address,
            aid: addressId,
            forceExUser: forceExUser,
            uid: uid,
            pass: hps,
            latitude,
            longitude
        }
    };

    return $.ajax(request);
};


const getAddressLatLng = (latitude , longitude) => {
    const request = {
        url: '/wservice/useraddressws.ashx?rv=' + Date.now(),
        method: 'GET',
        data: {
            action: 'get-address-lat-lng',
            latitude,
            longitude
        }
    };
    return $.ajax(request);
}

const addNewSubscriber = (firstName, lastName, mobile, email) => {
    const obj = { firstName: firstName, lastName: lastName, mobile: mobile, email: email };
    const request = {
        url: `${baseUrl}/subscriber/add`,
        method: 'POST',
        data: `=${JSON.stringify(obj)}`
    };

    return $.ajax(request);
};

const addNationalCodeAsync = (nationalCode) => {
    const request = {
        url: '/wservice/nationalcode.ashx?rv=' + Date.now(),
        method: 'POST',
        data: {
            nationalCode: nationalCode
        }
    };

    return $.ajax(request);
};

const getProducts = productIds => {
    const request = {
        url: '/_Products.ashx?rv=' + Date.now(),
        method: 'POST',
        data: {
            productIds
        }
    };

    return $.ajax(request);
};

const getShippingTypes = (addressId: number, shippingInsurance: boolean, forceExUser?: number, uid?: number, hps?: string): JQuery.jqXHR<ShippingItem[]> => {
    if (typeof forceExUser == 'undefined') {
        forceExUser = 0;
    }
    if (typeof uid == 'undefined') {
        uid = 0;
    }
    if (typeof hps == 'undefined') {
        hps = "";
    }

    const request = {
        url: `${baseUrl}/shipping/shippings`,
        method: 'GET',
        data: {
            addressId,
            shippingInsurance,
            forceExUser: forceExUser,
            uid: uid,
            pass: hps
        }
    };

    return $.ajax(request);
};

const getOrderSummary = (): JQuery.jqXHR<OrderSummary> => {
    const request = {
        url: `${baseUrl}/order/summary`,
        method: 'GET'
    };

    return $.ajax(request);
};

const getCartItems = (): JQuery.jqXHR<Order[]> => {
    const request = {
        url: `${baseUrl}/order/cart`,
        method: 'GET'
    };

    return $.ajax(request);
};

const removeUnavailableCartItems = (): JQuery.jqXHR => {
    const request = {
        url: `${baseUrl}/order/trimcart`,
        method: 'POST'
    };

    return $.ajax(request);
};

const saveCartItems = (quantities): JQuery.jqXHR => {
    const request = {
        url: `${baseUrl}/order/savecartitems`,
        data: `=${JSON.stringify(quantities)}`,
        method: 'POST'
    };

    return $.ajax(request);
};

const removeCartItem = (orderId): JQuery.jqXHR => {
    const request = {
        url: `${baseUrl}/order/removeCartItem?orderId=${orderId}`,
        method: 'DELETE'
    };

    return $.ajax(request);
};

const saveOrderDetails = (model: OrderDetails): JQuery.jqXHR => {
    const request = {
        url: `${baseUrl}/order/SaveOrderDetails`,
        data: `=${JSON.stringify(model)}`,
        method: 'POST'
    };

    return $.ajax(request);
};

const validateVoucher = (code: string): JQuery.jqXHR<VoucherResponse> => {
    const request = {
        url: `${baseUrl}/order/validate-voucher?code=${code}`,
        method: 'GET'
    };

    return $.ajax(request);
};

const validateInstallment = (code: string): JQuery.jqXHR<InstallmentResponse> => {
    const request = {
        url: `${baseUrl}/order/validate-installment?code=${code}`,
        method: 'GET'
    };

    return $.ajax(request);
};

const isFirstTimeUser = (): JQuery.jqXHR<boolean> => {
    const request = {
        url: `${baseUrl}/Subscriber/is-firsttime-user`,
        method: 'GET'
    };

    return $.ajax(request);
};

const ApiHelper = {
    getProvinces,
    getCities,
    getRegions,
    getSuburbs,
    getAddress,
    getAddresses,
    getAddressLatLng,
    deleteAddress,
    addOrUpdateAddressAsync,
    addNationalCodeAsync,
    getProducts,
    getShippingTypes,
    getOrderSummary,
    getCartItems,
    removeUnavailableCartItems,
    saveCartItems,
    removeCartItem,
    saveOrderDetails,
    validateVoucher,
    validateInstallment,
    addNewSubscriber,
    isFirstTimeUser
};

export default ApiHelper;
